export default __webpack_public_path__ + "static/media/professional-icon.0e7907b5.svg";